import { AbilityBuilder } from '@casl/ability';
import { SurfaceNodeActions } from 'services/authorization/actions';

export default function defineAdminPermissions(
  { can }: AbilityBuilder<any>,
  user: string,
) {
  can(SurfaceNodeActions.all, 'all');
}
